import * as React from 'react';
import { Logger } from '../../core';

const logger = Logger.getInstance();

/** Check if this is a Next.js navigation error (don't block these!) */
export const isNextJsNavigation = (error: unknown): boolean => {
  const nextError = error as { digest?: string };
  const isNotFound = nextError?.digest?.startsWith('NEXT_NOT_FOUND');
  const isRedirect = nextError?.digest?.startsWith('NEXT_REDIRECT');

  return Boolean(isNotFound || isRedirect);
};

/** Check if component returned a Promise (async component) */
export const isAsyncComponent = (result: unknown): result is Promise<React.ReactNode> => result instanceof Promise;

/** Handle component errors safely */
export const handleComponentError = (error: unknown, componentName: string) => {
  // Don't block Next.js navigation - let it through!
  if (isNextJsNavigation(error)) {
    throw error;
  }

  // Log error for debugging (only on server)
  if (typeof window === 'undefined') {
    logger.error(`Component crashed: ${componentName}`, error);
  }

  // Return nothing instead of crashing the page
  return null;
};
